export default "__VITE_ASSET__D$c3RTvt__"